import { render, staticRenderFns } from "./FloatingErecharge.vue?vue&type=template&id=6d3e4a56&"
import script from "./FloatingErecharge.vue?vue&type=script&lang=js&"
export * from "./FloatingErecharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports